export class Status {
  statusName: string;
  statusCode: string;
  metadata: any;
  rolesAllowedToViewItemsAtThisStatus: string[];
  rolesAllowedToEditItemsAtThisStatus: string[];
  itemAttributesVisibleAtThisStatus: string[];
  itemAttributesEditableAtThisStatus: string[];
  itemAtThisStatusIsAvailable: boolean;
  tasks: string[];
  isRemovable?: boolean;
  orderNumber: number;
  isCodeRequired: boolean;
  createdAt?: Date;
  updatedAt?: Date;
  createdBy?: string;
  updatedBy?: string;
  _id?: string;
}



// WEBPACK FOOTER //
// ./src/app/interfaces/status.ts